const enum SponsorableType {
    ELEMENT = 'element',
    EXHIBIT = 'exhibit',
    FACILITY = 'facility',
    SITE = 'site',
    TRAIL = 'trail',
    ZONE = 'zone',
}

export default SponsorableType